// Central backend endpoint configuration. Every network base URL in the app must come
// from here — no hardcoded hosts in components/utils (enforced by the Phase 0 gate,
// see docs/sdk-refactor/phases/phase-0-foundation.md).

const env = import.meta.env;

// Supabase edge functions (payments, promos, subscriptions, affiliates, cart recovery).
// Host fronts the Supabase project; keep the alias, never the raw *.supabase.co host.
export const EDGE_HOST = env.VITE_EDGE_HOST || "https://api.treatink.com";
export const SUPABASE_FN_BASE = `${EDGE_HOST}/functions/v1`;

// treatink-api (catalog, cutout labels, artwork assets, order intake) — used from Phase 2 on.
export const TREATINK_API_BASE = env.VITE_TREATINK_API_BASE || "https://treatinkapi.com";
export const TREATINK_PK = env.VITE_TREATINK_PK || "";
export const TREATINK_CHANNEL = env.VITE_TREATINK_CHANNEL || "treatink.com";

// SDK feature flags: CONFIGURED ⇒ ENABLED. When a publishable key is present in the
// build, the SDK flows are live by default; setting a flag to "0" is the explicit kill
// switch (rollback = env flip + redeploy, DECISIONS.md L3). Builds without a key stay
// fully legacy. Flag REMOVAL (deleting legacy branches) is Phase 6, after soak.
const configured = Boolean(env.VITE_TREATINK_PK);
export const TK_FLAGS = {
  designer: env.VITE_TK_DESIGNER === "1" || (configured && env.VITE_TK_DESIGNER !== "0"),
  catalog: env.VITE_TK_CATALOG === "1" || (configured && env.VITE_TK_CATALOG !== "0"),
};

// SDK transport mode: bundled fixtures (offline) in dev unless overridden; live in prod.
export const TK_MODE = env.VITE_TK_MODE || (env.DEV ? "fixtures" : "live");
// SKU the designer opens with when the user starts customizing before picking a product
// (the store's customize-first flow; the real variant is attached at product-select).
export const TK_DEFAULT_SKU = env.VITE_TK_DEFAULT_SKU || "SSGTTBC";

export const fnUrl = (name) => `${SUPABASE_FN_BASE}/${name}`;
